@import '../../shared';

.edu-section {
  clear: both;
  padding-top: 0.1rem;
  padding-bottom: 0.1rem;
  // 0.1rem padding remains to prevent the .edu-section__contents margins from
  // collapsing with adjascent elements
}

.edu-section__contents {
  margin-top: 4rem;
  margin-bottom: 4rem;
  // &:last-child {
  //   margin-bottom: 0;
  // }
}

.edu-section__title {
  @include container;
  margin-top: 4rem;
}

.edu-section__title + .edu-section__contents {
  margin-top: 0;
}

.page-viewer-container > .edu-section--default {
  &:first-child {
    > .edu-section__contents {
      margin-top: 0.8rem;
    }
  }
  &:last-child {
    > .edu-section__contents {
      margin-bottom: 0.8rem;
    }
  }
}

.edu-section-image + .edu-section--default > .edu-section__contents,
.edu-section--default + .edu-section--default > .edu-section__contents {
  margin-top: 0;
}

.edu-section--red {
  background: $red-background;

  h1,
  h2,
  h3,
  h4 {
    color: $red-section-heading;
  }
}

.edu-section--green {
  background: $green-background;

  h1,
  h2,
  h3,
  h4 {
    color: $green-section-heading;
  }
}

.edu-section--blue {
  background: $blue-background;

  h1,
  h2,
  h3,
  h4 {
    color: $blue-section-heading;
  }
}

.edu-section--yellow {
  background: $yellow-background;
}
